import { identity } from 'lodash';
import { get, post, put, del, search } from 'redux/shelf/api';
import { field } from 'redux/shelf';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';

export const actions = {
  fetchProducts: get`autocomplete/${session.getMerchant}/product-matches`(field('products')),
  updateProducts: put`autocomplete/${session.getMerchant}/product-matches`(field('products')),
  fetchSuggestions: get`autocomplete/${session.getMerchant}/suggestions`(identity),
  updateSuggestions: put`autocomplete/${session.getMerchant}/suggestions`(identity),
  fetchProductsByQuery: search.get`autocomplete`(({ items }) => ({ productsList: items }))
};

export const reducer = createReducer(actions);
